export default __webpack_public_path__ + "static/media/TE.7fb3c5b6.png";